import {ErrorModel, ResultModel} from '../../models';
import {Dispatch, AnyAction} from '@reduxjs/toolkit';
import {LoggerService} from '../../services';
import {SET_USER_PROFILE, SET_USER_IS_CONNECTED, SET_USER_TOKEN} from '../../reducers/UserReducer';
import {ACTION_CODE} from './_actionCode';

const FUNCTION_CODE = 'LOG_OUT';

export async function logOut(dispatch: Dispatch<AnyAction>) {
    try {
        LoggerService.logInfo('Action - logOut- Start');

        dispatch({
            type: SET_USER_PROFILE,
            payload: null
        });

        dispatch({
            type: SET_USER_IS_CONNECTED,
            payload: { userIsConnected: false }
        });

        dispatch({
            type: SET_USER_TOKEN,
            payload: { userToken: null }
        });

        LoggerService.logInfo('Action - logOut - End - Success');

        return ResultModel.newSuccessResult();
    }
    catch (error) {
        LoggerService.logInfo('logOut - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
